<!-- Modal Index -->
<div class="cs_modal popup__guide" *ngIf="exibirPopup">
    <div class="animated fadeIn">
        <span class="fa fa-times-circle cs_modal_close" (click)="fecharPopup()"></span>
        <div class="guide__header">
            <p [hidden]="id != 0" class="cs_label">Vem conferir as novidades por aqui!</p>
        </div>
        <div class="guide__main">
            <div [hidden]="id != 0">
                <img src="assets/images/others/guide/menu.png">
            </div>
            <div [hidden]="id != 1">
                <img src="assets/images/others/guide/navigation.png">
            </div>
            <!-- <div [hidden]="id != 2">
                <img src="assets/images/others/guide/perfil.png">
            </div> -->
            <div [hidden]="id != 2">
                <p class="cs_label">Obrigado pela sua atenção {{nome}}!</p>
                <button class="cs_botao" (click)="fecharPopup()">IR PARA NAVEGAÇÃO!</button>
                <p class="reset_label" (click)="resetarId()">Ler novamente</p>
            </div>
        </div>
        <div class="guide__footer" [hidden]="id == 2">
            <div class="footer__proximo" (click)="proximo()">
                <p class="cs_label">Próximo</p>
                <img class="proximo__icone" src="assets/images/icons/proximo.png">
            </div>
        </div>
    </div>
</div>

<div class="cs_modal popup__guide" *ngIf="exibirPopupPerfil">
    <div class="animated fadeIn">
        <span class="fa fa-times-circle cs_modal_close" (click)="fecharPopup()"></span>
        <div class="guide__header">
            <p [hidden]="id != 0" class="cs_label">Vem conferir as novidades por aqui!</p>
        </div>
        <div class="guide__main">
            <div [hidden]="id != 0">
                <img src="assets/images/others/guide/perfil.png">
            </div>
            <div [hidden]="id != 1">
                <p class="cs_label">Obrigado pela sua atenção {{nome}}!</p>
                <button class="cs_botao" (click)="fecharPopup()">IR PARA NAVEGAÇÃO!</button>
                <p class="reset_label" (click)="resetarId()">Ler novamente</p>
            </div>
        </div>
        <div class="guide__footer" [hidden]="id == 1">
            <div class="footer__proximo" (click)="proximo()">
                <p class="cs_label">Próximo</p>
                <img class="proximo__icone" src="assets/images/icons/proximo.png">
            </div>
        </div>
    </div>
</div>